<template>
    <v-menu v-model="menuIsOpen" :close-on-content-click="false" :nudge-width="200" offset-x offset-y>
        <template v-slot:activator="{ on, attrs }">
            <button
                class="toolbtn"
                type="button"
                v-bind="attrs"
                v-on="on"
                :disabled="selectedUsers.length === 0"
            >
                <span class="caret" aria-hidden="true"></span>
                <span>Назначить права</span>
            </button>
        </template>

        <v-card min-width="198px">
            <v-list dense>
                <v-list-item class="mx-3"><span class="black--text text-subtitle-2">ПРАВА</span></v-list-item>
                <v-list-item
                    v-for="role in roles"
                    :key="role.id"
                    class="text-btn-wrapper"
                    @click="reAssignPermissionMany(role.id)"
                >
                    <span class="mx-3 my-2">{{ role.name }}</span>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>


<script>
import { mapState } from 'vuex'
export default {
    name: 'AssignPermissionBtn',
    props: {
        selectedUsers: {
            type: Array,
            default: () => [],
        },
        projectId: {
            type: String,
            default: null,
        },
    },
    components: {},
    data: () => ({
        menuIsOpen: false,
    }),
    computed: {
        ...mapState(['roles']),
    },
    methods: {
        async reAssignPermissionMany(roleId) {
            const userIds = this.selectedUsers.map((user) => user.id)
            for (const userId of userIds) {
                await this.$store.dispatch('project/reAssignPermission', {
                    projectId: this.projectId,
                    userIdtoChange: userId,
                    roleId,
                })
            }
            this.menuIsOpen = false
            this.$parent.$emit('clearSelectedUsers')
        },
    },
    created() {},
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.toolbtn
    height: 34px
    display: inline-flex
    align-items: center
    gap: 8px
    padding: 0 16px
    border-radius: 4px
    border: 1px solid #BFC5D3
    background: #F6F7FA
    color: $text-color-new
    font-family: $font-family-base
    font-size: 11px
    font-weight: 800
    letter-spacing: .09em
    text-transform: uppercase
    cursor: pointer
    box-shadow: 0 1px 0 rgba(255, 255, 255, .85) inset
    transition: border-color .15s, color .15s, background .15s

    &:hover:not(:disabled)
        border-color: $dark-new

    &:disabled
        color: #A5A9B3
        opacity: .55
        cursor: not-allowed

.caret
    width: 0
    height: 0
    border-left: 4px solid transparent
    border-right: 4px solid transparent
    border-top: 5px solid currentColor
    opacity: .9
    flex-shrink: 0
</style>
